import React from 'react';

const iconPetProtector = props => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="48"
        height="48"
        rx="2"
        fill={props?.inactive ? '#f1f1f1' : '#EAF3F4'}
      />
      <path
        d="M0 2.41421C0 1.52331 1.07714 1.07714 1.70711 1.70711L24 24L46.2929 46.2929C46.9229 46.9229 46.4767 48 45.5858 48H0.999999C0.447714 48 0 47.5523 0 47V2.41421Z"
        fill={props?.inactive ? '#FAFAFA' : '#F2F8F9'}
      />
      <path
        d="M19.9695 24.9578C19.1311 24.6841 15.541 23.514 13.7595 22.9165C12.8554 25.2472 8.08288 37.8549 9.72868 40.0228C11.5416 42.4145 18.055 39.6115 19.9507 40.0228C21.8465 40.4358 21.6134 39.1172 21.6134 39.1172L19.9695 24.9578Z"
        fill={props?.inactive ? '#8D8D8D' : '#0A545F'}
      />
      <path
        d="M24.7446 17.8764C24.2472 17.1975 21.4175 17.3399 21.4175 17.3399C21.4175 17.3399 20.6996 15.7991 20.2366 15.5144C19.6953 15.1828 18.1859 15.2407 18.1859 15.2407C18.1859 15.2407 18.3267 13.0101 17.6462 12.8443C16.3479 12.5268 14.6195 19.4547 14.0767 21.7869C15.5392 22.3797 18.2781 23.4371 19.8238 23.6952L19.8081 23.5638C19.8081 23.5638 19.8613 22.4376 20.6137 22.1685C21.1189 21.9887 23.6185 21.4756 24.3177 20.7733C24.8308 20.2555 25.178 18.4676 24.7448 17.8763L24.7446 17.8764Z"
        fill={props?.inactive ? '#8D8D8D' : '#0A545F'}
      />
      <path
        d="M26.2286 29.0075C27.3455 28.6712 29.0833 28.0534 30.5177 27.1367C30.4614 26.3906 30.7023 25.5584 30.8055 25.0501C30.9666 24.2445 30.7523 23.7862 30.3222 22.635C30.2455 22.4285 29.8951 20.1307 29.1959 20.0587C28.5061 19.9883 27.5864 22.3127 27.5864 22.3127C27.5864 22.3127 25.5999 22.3127 25.3621 23.1981C25.0758 24.2617 23.9793 24.8405 23.9355 24.9953C23.7713 25.5944 24.0606 27.2212 25.0148 27.4699C25.5982 27.6217 26.0206 28.3787 26.2286 29.0075H26.2286Z"
        fill={props?.inactive ? '#8D8D8D' : '#0A545F'}
      />
      <path
        d="M31.0058 28.2737C30.9135 28.1893 30.84 28.0939 30.7759 27.9922C30.0047 28.4114 27.685 29.6393 26.3975 29.9913C26.923 32.469 26.6227 38.7228 26.6383 38.9919C26.6602 39.3892 26.4006 39.6364 26.593 39.9523C26.8855 40.4372 27.4627 40.4826 28.1416 40.359C28.822 40.2339 33.8822 41.637 37.0545 40.3105C40.9447 37.9689 34.4548 29.6268 31.0059 28.2737L31.0058 28.2737Z"
        fill={props?.inactive ? '#8D8D8D' : '#0A545F'}
      />
      <path
        d="M9.56228 39.2372C6.85933 37.16 6.8343 32.3765 6.1429 33.8221C5.49687 35.172 6.12882 38.4336 7.33641 39.8647C8.44542 41.1803 10.7323 41.1177 10.8246 40.2918"
        fill={props?.inactive ? '#8D8D8D' : '#0A545F'}
      />
      <path
        d="M38.2358 37.6465C39.2979 38.3144 41.2282 35.4675 39.628 34.5071C38.6206 33.9033 38.5095 33.7187 38.2249 33.2495C37.5413 32.1248 38.436 28.9808 40.1614 28.5756C41.444 28.2752 41.5269 29.4531 40.823 29.8379C39.1508 30.8327 39.0101 32.5017 40.1488 33.3151C40.7917 33.775 41.2453 34.1035 41.5269 35.128C41.9226 36.5749 40.7338 38.8759 38.4501 39.5985C38.4501 39.5985 37.1799 39.8848 36.9453 39.3639"
        fill={props?.inactive ? '#8D8D8D' : '#0A545F'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.6479 7.00307V13.2847C31.6479 15.7442 34.1456 17.525 36.5888 19.2669C36.818 19.4304 37.0468 19.5935 37.2729 19.7567C37.4991 19.5935 37.7279 19.4304 37.9571 19.2669C40.4003 17.525 42.8979 15.7442 42.8979 13.2847V7.00307L37.2729 4.90918L31.6479 7.00307ZM39.9328 9.47766L36.1767 13.4961L34.5655 11.9937L33.8979 12.7087L36.2066 14.9027L40.6479 10.1534L39.9328 9.47766Z"
        fill={props?.inactive ? '#8D8D8D' : '#016A78'}
      />
    </svg>
  );

export default iconPetProtector;
